import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-periscope",
  "use": "social-periscope-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 20\" id=\"social-periscope\">\n    <path d=\"M7.968 20C6.186 20 0 12.968 0 8.253 0 3.74 3.518 0 7.968 0c4.229 0 7.746 3.74 7.746 8.253C15.714 12.968 9.53 20 7.968 20zM4.1 4.9a4.881 4.881 0 0 0-1.025 3.032c0 2.486 2.14 4.61 4.919 4.61 2.505 0 4.646-2.124 4.646-4.61 0-2.756-2.141-4.881-4.646-4.881-.44 0-.864.053-1.267.154.665.287 1.13.945 1.13 1.71 0 1.03-.841 1.865-1.879 1.865A1.872 1.872 0 0 1 4.1 4.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol